import React, {Component} from "react";
import styles from "./Projects.module.scss";


class Projects extends Component {
    render() {
        return (
            <section className={` row-bottom-padded-md row-top-padded-md ${styles.fh5coprojects}`} id="fh5co-projects">
                <div className="container">
                    <div className={`row row-bottom-padded-md row-top-padded-md ${styles.homepagetopcontainer}`}>
                        <div className="col-lg-12 text-center">
                            <h2 className={`${styles.fh5colead} animate-box`}>Nous réalisons des applications Web</h2>
                            <p className={`${styles.fh5cosublead} animate-box`}> Nous sommes un studio web spécialisé dans le <strong>développement web</strong> et le <strong>développement mobile</strong> de solutions de qualité telles que le développement d'applications Web et de portails Web d'entreprise.
                            </p></div>
                    </div>
                    <div className={`row ${styles.capabilitieslist}`}>
                        <div className={`col-lg-4 col-md-6 col-xxs-12 ${styles.animatebox}`}>
                            <a href="/application-web" title="Les applications Web" className={styles.fh5coprojectitem}>
                                <img src="images/application-web.jpg" alt="Image" className="img-fluid" />
                                <div className={`${styles.fh5cotext}`}>
                                    <h2>Application Web</h2>
                                    <p>Développement d'applications Web spécifiques</p>
                                </div>
                            </a>
                        </div>
                        <div className={`col-lg-4 col-md-6 col-xxs-12 ${styles.animatebox}`}>
                            <a href="/portail-web-collaboratif" title="Les portails Web" className={styles.fh5coprojectitem}>
                                <img src="images/portail-intranet-extranet.jpg" alt="Image" className="img-fluid"/>
                                <div className={`${styles.fh5cotext}`}><h2>Portail intranet / extranet</h2>
                                    <p>Réalisation de portails Intranet / Extranet et collaboratif</p></div>
                            </a>
                        </div>
                        <div className={`col-lg-4 col-md-6 col-xxs-12 ${styles.animatebox}`}>
                            <a href="/application-iot" title="Les applications IoT" className={styles.fh5coprojectitem}>
                                <img src="images/iot.jpg" alt="Image" className="img-fluid"/>
                                <div className={`${styles.fh5cotext}`}><h2>Applications IoT</h2>
                                    <p>Création d'applications IoT (Objets connectés)</p></div>
                            </a>
                        </div>
                        <div className={`col-lg-4 col-md-6 col-xxs-12 ${styles.animatebox}`}>
                            <a href="/e-commerce" title="Les sites E-Business" className={styles.fh5coprojectitem}>
                                <img src="images/e-commerce.jpg" alt="Image" className="img-fluid"/>
                                <div className={`${styles.fh5cotext}`}><h2>Site E-Commerce</h2>
                                    <p>Réalisation de site E-Commerce sur-mesure innovants et performants</p></div>
                            </a>
                        </div>

                        <div className={`col-lg-4 col-md-6 col-xxs-12 ${styles.animatebox}`}>
                            <a href="/application-mobile" title="Les applications mobile" className={styles.fh5coprojectitem}>
                                <img src="images/application-mobile.jpg" alt="Image" className="img-fluid"/>
                                <div className={`${styles.fh5cotext}`}><h2>Application mobile</h2>
                                    <p>Nous réalisons de puissantes applications mobiles iOS et Android </p></div>
                            </a>
                        </div>
                        <div className={`col-lg-4 col-md-6 col-xxs-12 ${styles.animatebox}`}>
                            <a href="/conseil" title="Conseil audit et accompagnement" className={styles.fh5coprojectitem}>
                                <img src="images/site-internet.jpg" alt="Image" className="img-fluid"/>
                                <div className={`${styles.fh5cotext}`}><h2>Conseil, audit & accompagnement</h2>
                                    <p>Notre expérience et expertise entièrement à votre service.</p></div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

        );
    }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.jsx